module.exports = __webpack_public_path__ + "static/media/h04.d37e7788.jpg";